import canBeCloned from './can-be-cloned';
import canBeDragged from './can-be-dragged';
import canBeInteracted from './can-be-interacted';
import canBeNested from './can-be-nested';
import canBeRemoved from './can-be-removed';
import hasConstraints from './has-constraints';
import canBeRichEdited from './can-be-rich-edited';
import canBeSimpleEdited from './can-be-simple-edited';
import canBeSelected from './can-be-selected';
import canBeAligned from './can-be-aligned';
import canBeMoved from './can-be-moved';
import canBeTextResizable from './can-be-text-resizable';
import canBeHidden from './can-be-hidden';
import canBeSpaceResizable from './can-be-space-resizable';

export default {
  canBeCloned,
  canBeDragged,
  canBeInteracted,
  canBeNested,
  canBeRemoved,
  hasConstraints,
  canBeRichEdited,
  canBeSimpleEdited,
  canBeSelected,
  canBeAligned,
  canBeMoved,
  canBeTextResizable,
  canBeHidden,
  canBeSpaceResizable,
};
